import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useInfoBlockCategoriesForLocation.ts
function useInfoBlockCategoriesForLocation(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetInfoBlockCategoriesForLocation.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.locationId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useInfoBlockCategoriesForLocation };

//# sourceMappingURL=useInfoBlockCategoriesForLocation.js.map